import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { api } from '../api';
import { HeadActions } from '../components/Layout';

const emptyForm = {
  name: '',
  username: '',
  email: '',
  password: '',
  role: 'operator',
};

export default function Users() {
  const ctx = useOutletContext();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setError('');
    try {
      setUsers((await api.users()) || []);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onChange = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const onSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.createUser(form);
      setForm(emptyForm);
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this user?')) return;
    try {
      await api.deleteUser(id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Users</h1>
          <p>Add dashboard accounts for operators and admins.</p>
        </div>
        <HeadActions {...ctx} />
      </div>

      {error && <p className="error">{error}</p>}

      <section className="panel">
        <div className="panel-head">
          <strong>Add user</strong>
        </div>
        <form onSubmit={onSubmit}>
          <div className="form-grid">
            <label className="field">
              <span>Name</span>
              <input value={form.name} onChange={(e) => onChange('name', e.target.value)} required />
            </label>
            <label className="field">
              <span>Username</span>
              <input value={form.username} onChange={(e) => onChange('username', e.target.value)} required />
            </label>
            <label className="field">
              <span>Email</span>
              <input type="email" value={form.email} onChange={(e) => onChange('email', e.target.value)} required />
            </label>
            <label className="field">
              <span>Password</span>
              <input type="password" value={form.password} onChange={(e) => onChange('password', e.target.value)} required />
            </label>
            <label className="field">
              <span>Role</span>
              <select value={form.role} onChange={(e) => onChange('role', e.target.value)}>
                <option value="operator">operator</option>
                <option value="admin">admin</option>
              </select>
            </label>
          </div>
          <button className="btn btn-gold" type="submit" disabled={busy}>
            {busy ? 'Saving…' : 'Add user'}
          </button>
        </form>
      </section>

      <section className="panel">
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>NAME</th>
                <th>USERNAME</th>
                <th>EMAIL</th>
                <th>ROLE</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.username}</td>
                  <td className="muted">{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <button type="button" className="btn" onClick={() => remove(user.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
